export enum WaitlistStatus {
  allSubscribers = 'allSubscribers',
  notMember = 'notMember',
  convertedMember = 'convertedMember',
}
